export { default } from './logotype.svg';
